var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwardFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_5438_3",
    maskUnits: "userSpaceOnUse",
    x: 1.26392,
    y: 13.9673,
    width: 13,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.26392,
    y: 13.9673,
    width: 13,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9343 14.9673C10.7726 15.6248 9.4301 16 8 16C6.57036 16 5.2283 15.625 4.06684 14.968L3.27316 20.9435C3.1629 21.7737 4.06085 22.3635 4.77895 21.9327L7.48552 20.3087C7.8022 20.1187 8.19783 20.1187 8.51451 20.3087L11.2214 21.9328C11.9394 22.3637 12.8373 21.7739 12.7272 20.9438L11.9343 14.9673Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9343 14.9673C10.7726 15.6248 9.4301 16 8 16C6.57036 16 5.2283 15.625 4.06684 14.968L3.27316 20.9435C3.1629 21.7737 4.06085 22.3635 4.77895 21.9327L7.48552 20.3087C7.8022 20.1187 8.19783 20.1187 8.51451 20.3087L11.2214 21.9328C11.9394 22.3637 12.8373 21.7739 12.7272 20.9438L11.9343 14.9673Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9343 14.9673L12.9256 14.8358C12.8819 14.5064 12.6774 14.2203 12.38 14.0722C12.0825 13.9241 11.731 13.9334 11.4418 14.097L11.9343 14.9673ZM4.06684 14.968L4.5592 14.0976C4.27004 13.934 3.91852 13.9247 3.62112 14.0728C3.32373 14.2209 3.11929 14.507 3.07554 14.8363L4.06684 14.968ZM3.27316 20.9435L4.26446 21.0752L4.26446 21.0752L3.27316 20.9435ZM4.77895 21.9327L5.29345 22.7901L5.29345 22.7901L4.77895 21.9327ZM7.48552 20.3087L6.97102 19.4512L6.97102 19.4512L7.48552 20.3087ZM8.51451 20.3087L8.00001 21.1662L8.00001 21.1662L8.51451 20.3087ZM11.2214 21.9328L10.7069 22.7903L10.7069 22.7903L11.2214 21.9328ZM12.7272 20.9438L11.7359 21.0754L11.7359 21.0754L12.7272 20.9438ZM8 17C9.60717 17 11.1188 16.5778 12.4268 15.8377L11.4418 14.097C10.4263 14.6717 9.25303 15 8 15V17ZM3.57448 15.8384C4.8822 16.5781 6.39334 17 8 17V15C6.74737 15 5.57441 14.6719 4.5592 14.0976L3.57448 15.8384ZM3.07554 14.8363L2.28187 20.8118L4.26446 21.0752L5.05813 15.0996L3.07554 14.8363ZM2.28187 20.8118C2.06135 22.4721 3.85724 23.6519 5.29345 22.7901L4.26446 21.0752L4.26446 21.0752L2.28187 20.8118ZM5.29345 22.7901L8.00001 21.1662L6.97102 19.4512L4.26446 21.0752L5.29345 22.7901ZM8.00001 21.1662L8.00001 21.1662L9.02901 19.4512C8.39564 19.0712 7.60439 19.0712 6.97102 19.4512L8.00001 21.1662ZM8.00001 21.1662L10.7069 22.7903L11.7359 21.0754L9.02901 19.4512L8.00001 21.1662ZM10.7069 22.7903C12.143 23.652 13.9388 22.4725 13.7185 20.8123L11.7359 21.0754L11.7359 21.0754L10.7069 22.7903ZM13.7185 20.8123L12.9256 14.8358L10.943 15.0989L11.7359 21.0754L13.7185 20.8123Z",
    fill: "white",
    mask: "url(#path-1-outside-1_5438_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
    fill: "currentColor",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardFilled);
export default __webpack_public_path__ + "static/media/award-filled.62a2d4fa.svg";
export { ForwardRef as ReactComponent };